import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import _ from 'lodash';
import ApiService from "../api/api.service";
import JwtService from "../common/jwt.service";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        status: '',
        token: JwtService.getToken() || '',
        user : {},
        errors: {
            email: [],
            register: []
        },
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, token, user){
            state.status = 'success'
            state.token = token
            state.user = user
            JwtService.setToken(token.token);
        },
        auth_error(state){
            state.status = 'error'
        },
        logout(state){
            JwtService.unsetToken();
            window.localStorage.removeItem('user');

            state.status = ''
            state.token = ''
        },
        clearErrors(state){
            state.errors.email = '',
            state.errors.password = ''
        }
    },
    actions: {
        login(context, credentials) {
            return new Promise((resolve, reject) => {
                ApiService.post("/api/users/login", credentials)
                    .then(({data}) => {
                        context.commit("clearErrors");
                        if(typeof data.user != 'undefined') {
                            window.localStorage.setItem('user', JSON.stringify(data.user));
                        }
                        context.commit(
                            "auth_success", {state: 'success', token: data.token, user: data.user}
                        );

                        resolve(data);
                    })
                    .catch(({response}) => {

                        if(response.status === 422) {

                            context.commit(
                                "setError",
                                {target: 'register', errors: response.data.status}
                            );
                        }
                        reject(response);
                    });
            });
        },
        logout(context, payload) {
            // ApiService.setHeader();
            return new Promise((resolve, reject) => {
                ApiService.get("api/users/logout")
                    .then(({data}) => {
                        context.commit("logout");
                        resolve(data);
                    })
                    .catch(({response}) => {
                        console.log('response :>> ', response);
                        context.commit(
                            "auth_error",
                            {target: 'logout', message: response?.data?.status}
                        );
                        reject(response);
                    });
            });
        },
        register(context, credentials) {
            return new Promise((resolve, reject) => {
                ApiService.post("/api/users", credentials)
                    .then(({data}) => {
                        // context.commit(
                        //     "auth_success", {state: 'success', token: data.token, user: data.user}
                        // );
                        resolve(data);
                    })
                    .catch(({response}) => {

                        if(response.status === 422) {

                            context.commit(
                                "setError",
                                {target: 'register', errors: response.data.status}
                            );
                        }
                        reject(response);
                    });
            });
        },
        forget(context, email) {
            return new Promise((resolve, reject) => {
                ApiService.post("/api/forget", email)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(({response}) => {

                        if(response.status === 422) {

                            context.commit(
                                "setError",
                                {target: 'forget', errors: response.data.status}
                            );
                        }
                        reject(response);
                    });
            });
        },
        me(context, credentials) {
            return new Promise((resolve, reject) => {
                ApiService.get("/api/me")
                    .then(({data}) => {
                        context.commit("clearErrors");
                        if(typeof data.user != 'undefined') {
                            window.localStorage.setItem('user', JSON.stringify(data.user));
                        }
                        context.commit(
                            "auth_success", {state: 'success', token: data.token, user: data.user}
                        );

                        resolve(data);
                    })
                    .catch(({response}) => {

                        if(response.status === 422) {

                            context.commit(
                                "setError",
                                {target: 'register', errors: response.data.status}
                            );
                        }
                        reject(response);
                    });
            });
        },

    },
    getters : {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        loginErrors: state => state.errors.email,
        getUserData: state => state.user
    }
})
